import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn, numberFormatter } from "@/lib/utils";
import { TERMS_OF_USE_PAGE } from "@/settings/constant";
import { Button, Divider, Typography } from "@bookips/sds";
import Link from "next/link";
import React from "react";
import { AdditionalPayment } from "./AdditionalPayment";
import { DeliveryFeeSection } from "./DeliveryFee";
import { DiscountSection } from "./Discount";
import { PriceRow } from "./PriceRow";
export const CheckoutPayment = (param)=>{
    let { paymentInfo , deliveryFee , discount , paymentMethod , paymentHandle , paymentReady , submitLabel  } = param;
    const { amount , total , discountedTotal , savedPointAmount  } = paymentInfo;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("sticky top-[107px]", "flex flex-col gap-6 rounded-lg bg-white p-6", "max-sm:rounded-none max-sm:border-none max-sm:px-5 max-sm:py-6", "shadow-sm max-lg:border max-lg:border-gray-100 max-lg:shadow-none"),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h6",
                className: "flex items-center gap-2",
                children: "결제 금액"
            }),
            /*#__PURE__*/ _jsxs("dl", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(PriceRow, {
                                label: "상품 금액",
                                amount: amount,
                                variant: "body1"
                            }),
                            deliveryFee && /*#__PURE__*/ _jsx(DeliveryFeeSection, {
                                deliveryFee: deliveryFee
                            }),
                            (discount.baseDiscountAmount > 0 || discount.discountedAmount > 0 || discount.deliveryFeeCouponAmount > 0) && /*#__PURE__*/ _jsx(DiscountSection, {
                                discount: discount
                            })
                        ]
                    }),
                    paymentMethod && /*#__PURE__*/ _jsx(AdditionalPayment, {
                        paymentMethod: paymentMethod
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        className: "bg-gray-900/90"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ _jsxs("dd", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle1",
                                        className: "text-strong",
                                        children: "총 결제금액"
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "h6",
                                        className: "text-strong",
                                        children: [
                                            numberFormatter(discountedTotal),
                                            "원"
                                        ]
                                    })
                                ]
                            }),
                            savedPointAmount > 0 && /*#__PURE__*/ _jsxs("dd", {
                                className: "flex items-center justify-end gap-1.5",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body2",
                                        className: "text-status-data",
                                        children: "적립 포인트"
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "subtitle2",
                                        className: "text-status-data",
                                        children: [
                                            "+ ",
                                            numberFormatter(savedPointAmount),
                                            "원"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: (e)=>{
                            return paymentHandle === null || paymentHandle === void 0 ? void 0 : paymentHandle(e);
                        },
                        disabled: !paymentReady,
                        size: "xl",
                        className: "w-full",
                        children: submitLabel !== null && submitLabel !== void 0 ? submitLabel : "".concat(numberFormatter(discountedTotal), "원 결제하기")
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        variant: "body2",
                        className: "text-secondary text-center",
                        children: [
                            "결제하기 진행 시",
                            " ",
                            /*#__PURE__*/ _jsx(Link, {
                                href: TERMS_OF_USE_PAGE,
                                target: "_blank",
                                onClick: ()=>{
                                    // mx-317
                                    mixpanelEvent("Guide Button Clicked", {
                                        "Guide Categories": "이용약관",
                                        "Guide URL": TERMS_OF_USE_PAGE
                                    });
                                },
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "underline underline-offset-2",
                                    children: "이용약관"
                                })
                            }),
                            "에 동의한 것으로 간주합니다."
                        ]
                    })
                ]
            })
        ]
    });
};
